import { Component, Input, OnInit } from '@angular/core';
import { environment } from '../../../environments/environment';
import { SpinnerService } from '../../common/components/spinner/overlay-spinner.service';
import { AdminApiHandlerService } from '../services/api-handler/api-handler.service';
import { OrchestrationService } from '../services/orchestration-service/orchestration.service';
import { MatDialog, MatTableDataSource } from '@angular/material';
import { RentalEvCreditsPopupComponent } from '../dailag_components/rental-ev-credits-popup/rental-ev-credits-popup.component';
import { convertUTCToAMPM, convertUTCToMMDDYYYY } from '../../common/helpers/utils';
import { FinegrainRolesService } from '../../common/services/finegrain-roles/finegrain-roles.service';
import { select } from '@angular-redux/store';
import { UserRoleState } from '../../store/user-role/user-role-state.model';
import { Observable } from 'rxjs';
import { MatCard, MatCardTitle } from '@angular/material/card';
import { NgIf } from '@angular/common';
import { MatButton } from '@angular/material/button';
import { MatTable, MatColumnDef, MatHeaderCellDef, MatHeaderCell, MatCellDef, MatCell, MatHeaderRowDef, MatHeaderRow, MatRowDef, MatRow } from '@angular/material/table';
import { TranslatePipe } from '@ngx-translate/core';
@Component({
    selector: 'app-rental-ev',
    templateUrl: './rental-ev.component.html',
    styleUrls: ['./rental-ev.component.scss'],
    imports: [MatCard, MatCardTitle, NgIf, MatButton, MatTable, MatColumnDef, MatHeaderCellDef, MatHeaderCell, MatCellDef, MatCell, MatHeaderRowDef, MatHeaderRow, MatRowDef, MatRow, TranslatePipe]
})
export class RentalEvComponent implements OnInit {
  /**
  * @property to store the consumed balance days information
  */
  public consumedDays: number;
  /**
  * @property to store the reserved balance days information
  */
  public reservedDays: number;
  /**
  * @property to store the remaining balance days information
  */
  public remainingDays: number;
  /**
  * @property to store the original balance days information
  */
  public originalDays: number;
  /**
  * @property Will contain vehicle details payload
  */
  @Input() vehicleDetails: object;
  /**
  * @property Will contain the boolean value when rental EV show/hide details clicked
  */
  public rentalEvHistoryBtnClicked = false;

  /**
  * @property Will contain the list of header names of EV rental history table
  */
  public headersList: string[];

  /**
  * @property Will contain the rental EV reservation history details
  */
  public reservationDetails: any;

  /**
  * @property Will contain the value of the credit to be applied when confirmed in dialog
  */
  public creditToBeApplied: number
 
  public isEvCreditAdmin: boolean;
  /**
 *@arg Property to observe the redux customer store
 **/
  @select('userRole') readonly userRoleObservable: Observable<UserRoleState>;
  /**
  * @property Will contain the response payload from the customer/fleetinfo fetch
  */
  public responsePayload: any;
  /**
  * @property Will contain the rental EV reservation history details
  */
  public rervationsDataSource: MatTableDataSource<any>;
  /**
  * @property Will contain the list of column names for the EV rental history table
  */
  public displayedColumns: string[] = ['date', 'dealer', 'vehicleType', 'timeStamp', 'numOfDays'];
  /**
  * @property {boolean} showRentavEvFeature - Determines if the vehicle is eligible for Rental EV Credit based on conditions.
  */
  public showRentavEvFeature: boolean = false;
  /**
  * @property {boolean} showError - Flag to control visibility of error messages.
  */
  public showError: boolean = false;
  /**
  * @property {boolean} isVehicleNotEligibleForRental - Indicates if the vehicle fails eligibility and hides EV Credit UI.
  */
  public isVehicleNotEligibleForRental: boolean = false;
  /**
  * @property {string} errorMessage - Message displayed for ineligible vehicles or API failures.
  */
  public errorMessage: string = '';

  constructor(
    public spinner: SpinnerService,
    public apiHandler: AdminApiHandlerService,
    public orch: OrchestrationService,
    public fineGrainRolesService: FinegrainRolesService,
    public dialog: MatDialog
  ) {}
  /**
  * @method ngOnInit
  * Initializes the component, evaluates eligibility, and triggers data fetch if eligible.
  */
  ngOnInit(): void {
    const vehicleData: any = this.vehicleDetails || {};
    const modelCode = Number(
      (vehicleData.modelCode != null ? vehicleData.modelCode : (vehicleData.model && vehicleData.model.modelCode))
    );
    const RZ_ELIGIBLE_MODEL_CODES = [9902, 9903, 9904, 9906, 9907, 9908];
    const hasGuid = !!vehicleData.subscriberGuid;
    const isRZ = vehicleData.carlineName === 'RZ';
    const isUS = vehicleData.region === 'US';
    const isEligibleModel = RZ_ELIGIBLE_MODEL_CODES.indexOf(modelCode) > -1;
    const isElectric =(vehicleData.fuelType && vehicleData.fuelType.toLowerCase() === 'electric') || vehicleData.fuelType === 'E';
    const isRecentYear = Number(vehicleData.modelYear) >= 2023;
    // Evaluate eligibility based on all acceptance criteria
    this.showRentavEvFeature = isElectric && isRecentYear && hasGuid && isRZ && isUS && isEligibleModel;
     if (this.showRentavEvFeature) {
       this.getRentalCreditBalance();
       const availableRoles = this.fineGrainRolesService.getUserAvailableRoles();
       this.isEvCreditAdmin = (availableRoles || []).some(function(role) { return role === 'EV_CREDIT_ADMIN'; });
     } else {
       this.isVehicleNotEligibleForRental = true;
       //this.errorMessage = 'Vehicle not eligible for Rental EV Credit';
     }
   }
  /**
   * @method getRentalCreditBalance will get the rental EV credit balance
   **/
  public getRentalCreditBalance(): void {
    if (this.vehicleDetails['subscriberGuid'] && this.vehicleDetails['vin']) {
      const spinnerRef = this.spinner.open();
      this.apiHandler.getRequest(environment.rental_ev.apis.summary, {
        type: 'rental-summary', params: {
          guid: this.vehicleDetails['subscriberGuid'],
          vin: this.vehicleDetails['vin']
        }
      }).subscribe({
        next: (response) => {
          this.errorMessage = '';
          spinnerRef.close();
          if (response['payload'] && response['payload'].length > 0) {
            this.responsePayload = response['payload'][0];
            this.originalDays = this.responsePayload['originalBalance'];
            this.consumedDays = this.responsePayload['consumedBalance'];
            this.reservedDays = this.responsePayload['reservedBalance'];
            this.remainingDays = this.responsePayload['remainingBalance'];
            this.rervationsDataSource = this.responsePayload['reservations'];
          } 
          else {
            this.showRentavEvFeature = false;
            this.isVehicleNotEligibleForRental = false;
            this.errorMessage = response['status']['messages'][0]['description'];
          }
        },
        error: (error) => {
          spinnerRef.close();
          this.orch.showError(error);
        }
      })
    }
  }

  /**
  * @function showAddTrialServicesModal Opens the Modal pop up which shows the info regarding the trail services availability
  **/
  public openSetCreditModal(): void {
    const dialogRef = this.dialog.open(RentalEvCreditsPopupComponent, {
      width: '19.875em'
    });

    dialogRef.afterClosed().subscribe(data => {
      if (data && parseInt(data) > 0) {
        this.creditToBeApplied = parseInt(data);

        const payload = {
          customerId: this.vehicleDetails['subscriberGuid'],
          subscriptionId: this.vehicleDetails['vin'],
          offerCode: "EVCredit",
          adjustBalance: this.creditToBeApplied
        }

        this.updateRentalCreditBalance(payload);
      }
    });
  }

  /**
   * @method showAndHideDetails will get the rental EV history details
   **/
  public showAndHideDetails(): void {
    this.rentalEvHistoryBtnClicked = !this.rentalEvHistoryBtnClicked;
  }

  /**
   * @method formatRentalDate formats the rental date time
   **/
  public formatRentalDate(input): string {
    if (!!input && input != 'null') {
      return convertUTCToMMDDYYYY(input);
    }
    return '';
  }

    /**
   * @method formatPickupTime formats the pickup time
   **/
  public formatPickupTime(input): string {
    if (!!input && input != 'null') {
      return convertUTCToAMPM(input);
    }
    return '';
  }

  /**
   * @method showAndHideDetails formats the input value and return '' if input is undefined or null
   **/
  public formatRowValue(input): string {
    if (!!input && input != 'null') {
      return input;
    }
    return '';
  }

  /**
   * @method formatRentalDays formats the rental days
   **/
  public formatRentalDays(input): string {
    if (!!input && input != 'null') {
      if (parseInt(input) > 1) {
        return input + ' Days'
      }
      return input + ' Day'
    }
    return '';
  }

  /**
   * @method updateRentalCreditBalance will apply credit to customers vehicle
   **/
  public updateRentalCreditBalance(payload) {
    if (this.vehicleDetails['subscriberGuid'] && this.vehicleDetails['vin']) {
      const spinnerRef = this.spinner.open();
      this.apiHandler.putRequest(environment.rental_ev.apis.summary, payload, {
        type: 'rental-summary', params: {
          guid: this.vehicleDetails['subscriberGuid'],
          vin: this.vehicleDetails['vin']
        }
      }).subscribe({
        next: (response) => {
          spinnerRef.close();
          this.getRentalCreditBalance();
        },
        error: (error) => {
          spinnerRef.close();
          this.orch.showError(error);
        }
      })
    }
  }
}
